import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { initializeApp } from "firebase/app";
import {
  getAuth,
  onAuthStateChanged,
  signOut
} from "firebase/auth";
import { ThemeProvider } from 'styled-components';
import Login from "./Login";
import Home from "./Home";
import Casos from "./Casos";
import Terminos from "./Terminos";
import Politica from "./Politica";
import PrivateRoute from "./PrivateRoute";
import Layout from './components/Layout';
import firebaseConfig from './firebaseConfig';
import { lightTheme, darkTheme } from './theme';

// Inicializar Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const Dashboard = ({ user, onLogout }) => (
  <div className="body" style={{ padding: 20 }}>
    <h2>Bienvenido, {user.email}</h2>
    <button onClick={onLogout}>Cerrar sesión</button>
  </div>
);

const App = () => {
  const [user, setUser] = useState(null);
  const [idToken, setIdToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const savedMode = localStorage.getItem('darkMode');
    if (savedMode) {
      setDarkMode(savedMode === 'true');
    }
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        const token = await currentUser.getIdToken();
        setIdToken(token);
      } else {
        setUser(null);
        setIdToken(null);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const toggleDarkMode = () => {
    setDarkMode(prev => {
      localStorage.setItem('darkMode', !prev);
      return !prev;
    });
  };

  const handleLogout = async () => {
    await signOut(auth);
  };

  if (loading) return <p>Cargando...</p>;

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <Router>
        <Layout user={user} onLogout={handleLogout} onToggleDarkMode={toggleDarkMode} darkMode={darkMode}>
          <Routes>
            <Route
              path="/"
              element={
                user ? (
                  <Dashboard user={user} onLogout={handleLogout} />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />
            <Route
              path="/login"
              element={user ? <Navigate to="/home" replace /> : <Login />}
            />
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/home" element={<PrivateRoute element={<Home />} user={user} />} />
            <Route path="/casos" element={<PrivateRoute element={<Casos user={user} idToken={idToken} />} user={user} idToken={idToken} />} />
            <Route path="/terminos" element={<Terminos />} />
            <Route path="/politica" element={<Politica />} />
            <Route path="*" element={<Navigate to={user ? "/home" : "/login"} replace />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
};

export default App;
